<template>
	<div class="table_div">
		<el-form :inline="true" class="select_form">
			<el-form-item>
				<h3>企业列表</h3>
			</el-form-item>
			<!-- <el-form-item>
				<el-button type='primary' @click="checkComInfo">企业信息</el-button>
			</el-form-item> -->
			<el-form-item>
				<el-date-picker v-model='infoData.yearNum' type="year" placeholder="选择年份" :default-value="new Date()" />
			</el-form-item>
			<el-form-item>
				<el-cascader placeholder="请选择行政区划" filterable style="width: 300px" :options="infoData.regionDataList"
					v-model="infoData.regionName" :props="{ checkStrictly: true ,value:'text',label:'text'}" clearable>
				</el-cascader>
			</el-form-item>
			<el-form-item>
				<el-input v-model="infoData.searchInput" placeholder="请输入单位名称" clearable @clear='getTableData'>
					<template #append>
						<el-button icon="Search" @click="getTableData" />
					</template>
				</el-input>
			</el-form-item>
		</el-form>
		<el-table :data="infoData.tableData"  stripe border
			 table-layout="fixed" v-loading='infoData.loading' height='86%' @select="handleSelect" ref='tableData'  highlight-current-row
			@current-change="handleTableChange">
			<el-table-column type="selection" width="55" />
			<el-table-column prop="companyName" label="单位名称" />
			<el-table-column prop="yearNum" label="年度" />
			<el-table-column prop="createTime" label="操作" width='150'>
				<template #default="scope">
					<el-button type='primary' @click="checkOpenInfo(scope.row.id)">公开信息</el-button>
				</template>
			</el-table-column>
		</el-table>

		<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
			:current-page="infoData.pageInfo.pageIndex" :page-sizes="[20, 50, 100,200,500,1000]" :page-size="infoData.pageInfo.pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="infoData.pageInfo.totalRowCount"
			v-if='infoData.pageInfo.totalRowCount' class='pageinfo'>
		</el-pagination>
		<el-dialog v-model="infoData.publicationDetailVisible" width='80%' :before-close="handleClose">
			<template #header="{ close, titleId, titleClass }">
				<div class="my-header">
					<h4 :id="titleId" :class="titleClass">{{infoData.publicationDetailItem.companyName}}</h4>
				</div>
			</template>
			<div class="publicationInfoDetailContainer">
				<div class="pub_detail_basicInfo" style='margin-bottom:120px'>
					<el-form :inline="true" class="select_form">
						<el-form-item>
							<h3><span style="color: #ea5b24;">公开年度：</span>{{ infoData.publicationDetailItem.yearNum }}</h3>
						</el-form-item>
						<el-form-item>
							<h3><span style="color: #ea5b24;">企业信息：</span>{{ infoData.publicationDetailItem.qysm }}</h3>
						</el-form-item>

					</el-form>
				</div>
				<el-tabs>
					<el-tab-pane>
						<template #label>
							<span class="custom-tabs-label">
								<span>基本信息</span>
							</span>
						</template>
						<el-card class="box-card" style='width:90%;margin:0 auto'>
							<el-form v-model="infoData.publicationDetailItem" label-position="left" label-width="200px">
								<el-row>
									<el-col :span="12">
										<el-form-item label="单位名称">
											<span>{{infoData.publicationDetailItem.companyName}}</span>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="统一社会信用代码" prop="OrgCode">
												<span>{{infoData.publicationDetailItem.companyCode}}</span>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="12">
										<el-form-item label="企业形象照片">
											<img width="200" height="150" v-if="infoData.publicationDetailItem.companyPhoto"
												:src="PHOTO_BASE_URL + infoData.publicationDetailItem.companyPhoto"
												class="avatar" />
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="企业营业执照（盖章）">
											<a v-if="infoData.publicationDetailItem.companyCard" target="blank"
												:href="PHOTO_BASE_URL + infoData.publicationDetailItem.companyCard">{{ getFileName(infoData.publicationDetailItem.companyCard) }}</a>
											<span v-else>无</span>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="12">
										<el-form-item label="单位联系电话" prop="CompanyTel">
											<el-input v-model="infoData.publicationDetailItem.companyTel" style="width: 500px"
												clearable />
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="单位性质" prop="regionName">
											<el-input v-model="infoData.publicationDetailItem.companyNature" style="width: 500px"
												clearable />
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="24">
										<el-form-item label="单位地址" prop="address">
											<el-input v-model="infoData.publicationDetailItem.address" clearable />
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="12">
										<el-form-item label="生产经营" prop="sCjy">
											<el-input v-model="infoData.publicationDetailItem.xydj" clearable />
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="生产经营" prop="qygw">
											<el-input v-model="infoData.publicationDetailItem.sCjy" clearable />
										</el-form-item>
									</el-col>
								</el-row>

								<el-row>
									<el-col :span="12">
										<el-form-item label="地图（经度）" prop="xd">
											<el-input v-model="infoData.publicationDetailItem.xd" clearable />
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="地图（纬度）" prop="yd">
											<el-input v-model="infoData.publicationDetailItem.yd" clearable />
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="12">
										<el-form-item label="法人代表" prop="faRen">
											<el-input v-model="infoData.publicationDetailItem.faRen" clearable />
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="法人代表手机" prop="telephone">
											<el-input v-model="infoData.publicationDetailItem.telephone" clearable />
										</el-form-item>
									</el-col>
								</el-row>

								<el-row>
									<el-col :span="12">
										<el-form-item label="环保专员" prop="hbfzr">
											<el-input v-model="infoData.publicationDetailItem.hbfzr" clearable />
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="环保专员手机（可找回密码）" prop="tel">
											<el-input v-model="infoData.publicationDetailItem.tel" clearable
												placeholder="通过此号码找回账号密码" />
										</el-form-item>
									</el-col>
								</el-row>

								<el-row>
									<el-col :span="12">
										<el-form-item label="联系QQ号" prop="qq">
											<el-input v-model="infoData.publicationDetailItem.qq" clearable />
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="电子邮箱" prop="email">
											<el-input v-model="infoData.publicationDetailItem.email" clearable />
										</el-form-item>
									</el-col>
								</el-row>

								<el-row>
									<el-col :span="12">
										<el-form-item label="ISO14001认证" prop="ISO">
											<el-input v-model="infoData.publicationDetailItem.iso" clearable />
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="预警体系：" prop="yjtx">
											<el-input v-model="infoData.publicationDetailItem.yjtx" clearable />
										</el-form-item>
									</el-col>
								</el-row>

								<el-row>
									<el-col :span="12">
										<el-form-item label="生产规模" prop="scgm">
											<el-input v-model="infoData.publicationDetailItem.scgm" clearable />
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="生产工艺的名称" prop="registType">
											<el-input v-model="infoData.publicationDetailItem.scgyml" clearable />
										</el-form-item>
									</el-col>
								</el-row>

								<el-row>
									<el-col :span="12">
										<el-form-item label="注册类型" prop="industryFullPath">
											<el-input v-model="infoData.publicationDetailItem.registType" clearable>
											</el-input>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="占地面积" prop="gklx">
											<el-input v-model="infoData.publicationDetailItem.areaAcreage" clearable />
										</el-form-item>
									</el-col>
								</el-row>

								<el-row>
									<el-col :span="12">
										<el-form-item label="产品出口" prop="areaAcreage">
											<el-input v-model="infoData.publicationDetailItem.cpck" clearable />
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="隶属关系" prop="lsgx">
											<el-input v-model="infoData.publicationDetailItem.lsgx" clearable />
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="12">
										<el-form-item label="所属行业" prop="areaAcreage">
											<el-input v-model="infoData.publicationDetailItem.industryFullPath" clearable />
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="管控类型" prop="lsgx">
											<el-input v-model="infoData.publicationDetailItem.gklx" clearable />
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="12">
										<el-form-item label="现有生态环境应急资源" prop="areaAcreage">
											<el-input v-model="infoData.publicationDetailItem.styjzy" clearable />
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="术语解释" prop="SYJS">
											<el-input v-model="infoData.publicationDetailItem.syjs" clearable />
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="12">
										<el-form-item label="投产日期" prop="areaAcreage">
											<!-- <el-input v-model="infoData.publicationDetailItem.workDate" clearable/> -->
											<span>{{dateTrimmer(infoData.publicationDetailItem.workDate)}}</span>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="生产天数" prop="SYJS">
											<el-input v-model="infoData.publicationDetailItem.workDay" clearable />
										</el-form-item>
									</el-col>
								</el-row>
								<el-form-item label="单位简介" prop="qysm">
									<el-input type="textarea" autosize style="width: 540px"
										v-model="infoData.publicationDetailItem.qysm" clearable>
									</el-input>
								</el-form-item>

								<!-- <el-form-item class="button-container">
									<el-button type="primary" @click="handleEditComInfo()" v-loading="infoData.loading">保存
									</el-button>
								</el-form-item> -->
							</el-form>
							<el-form-item>
								<h3><span style="color: #ea5b24;">法人承诺：</span>{{ infoData.publicationDetailItem.FaRenCN }}</h3>
							</el-form-item>
							<el-form-item>
								<h3><span style="color: #ea5b24;">负责人承诺：</span>{{ infoData.publicationDetailItem.fzrcn }}</h3>
							</el-form-item>
						</el-card>
					</el-tab-pane>
					<el-tab-pane v-if='infoData.publicationDetailSubItem.xK8.length>0'>
						<template #label>
							<span class="custom-tabs-label">
								<span>行政许可</span>
							</span>
						</template>
						<el-alert title="若附件不能下载，请联系公开单位，依申请获取附件内容" type="warning" :closable="false">
						</el-alert>
						<div class="pub_detail_item_contents">
							<div class="pub_detail_item" v-for="(item, index) in infoData.publicationDetailSubItem.xK8"
								:key="item.id">
								<p>编号：{{ item.code }}</p>
								<p>获取时间：{{ dateTrimmer(item.getDate) }}</p>
								<p>许可名称：{{ item.name }}</p>
								<p>核发机关：{{ item.org }}</p>
								<p>有效期限：{{ dateTrimmer(item.validDate)  }}</p>
								<p>主要许可事项：{{ item.remark }}</p>

								<p>
									获得许可的审批文件：
									<a v-if="item.fileUrl" target="blank" download
										:href="FILE_BASE_URL + item.fileUrl">{{ getFileName(item.fileUrl) }}</a>
									<span v-else>无</span>
								</p>
							</div>
						</div>
					</el-tab-pane>
					<el-tab-pane v-if='infoData.publicationDetailSubItem.jS9.length>0'>
						<template #label>
							<span class="custom-tabs-label">
								<span>环境保护税</span>
							</span>
						</template>
						<div class="pub_detail_item_contents">
							<div class="pub_detail_item" v-for="(item, index) in infoData.publicationDetailSubItem.jS9"
								:key="item.id">
								<p>环境保护税分税目：{{ item.name }}</p>
								<p>缴纳额：{{ item.needMoney }}</p>
								<p>实际缴纳总额：{{ item.actualMoney }}</p>
								<p>依法依规享受税收减征或免征的情况：{{ item.remark }}</p>
							</div>
						</div>
					</el-tab-pane>
					<el-tab-pane v-if='infoData.publicationDetailSubItem.bX10.length>0'>
						<template #label>
							<span class="custom-tabs-label">
								<span>环境污染责任保险</span>
							</span>
						</template>
						<div class="pub_detail_item_contents">
							<div class="pub_detail_item" v-for="(item, index) in infoData.publicationDetailSubItem.bX10"
								:key="item.id">
								<p>保险公司：{{ item.companyName }}</p>
								<p>险种名称：{{ item.name }}</p>
								<p>保险金额：{{ item.money }}</p>
								<p>生效时间：{{dateTrimmer(item.startDate) }}</p>
								<p>有效期限：{{ dateTrimmer(item.validDate) }}</p>
							</div>
						</div>
					</el-tab-pane>
					<el-tab-pane v-if='infoData.publicationDetailSubItem.wR12.length>0'>
						<template #label>
							<span class="custom-tabs-label">
								<span>污染防治设施</span>
							</span>
						</template>
						<el-alert title="若附件不能下载，请联系公开单位，依申请获取附件内容" type="warning" :closable="false">
						</el-alert>
						<div class="pub_detail_item_contents">
							<div class="pub_detail_item" v-for="(item, index) in infoData.publicationDetailSubItem.wR12"
								:key="item.id">
								<p>对应的产污环节：{{ item.buildStep }}</p>
								<p>运维方：{{ item.companyName }}</p>
								<p>污染防治设施的名称：{{ item.machineName }}</p>
								<p>处理的污染物：{{ item.pollutants }}</p>
								<p>对应排污口的名称、编号：{{ item.portNameCode }}</p>
								<p>主要原因：{{ item.remark }}</p>
								<p>时长：{{ item.timeLong }}</p>
								<p>次数：{{ item.times }}</p>
								<p>有效期限：{{ dateTrimmer(item.validDate)  }}</p>

								<p>
									运维方资质文件
									<a v-if="item.companyFile" target="blank" download
										:href="FILE_BASE_URL + item.companyFile">{{ getFileName(item.companyFile) }}</a>
									<span v-else>无</span>
								</p>
							</div>
						</div>
					</el-tab-pane>
					<el-tab-pane v-if='infoData.publicationDetailSubItem.pfqN13.length>0'>
						<template #label>
							<span class="custom-tabs-label">
								<span>企业监测达标</span>
							</span>
						</template>
						<el-alert title="若附件不能下载，请联系公开单位，依申请获取附件内容" type="warning" :closable="false">
						</el-alert>
						<div class="pub_detail_item_contents">
							<div class="pub_detail_item" v-for="(item, index) in infoData.publicationDetailSubItem.pfqN13"
								:key="item.id">
								<p>委托的供第三方机构名称：{{ item.companyName }}</p>
								<p>自行监测天数（次数）：{{ item.monitorDays }}</p>
								<p>全年生产天数：{{ item.workDays }}</p>
								<p>超标次数：{{ item.overproofTimes }}</p>
								<p>达标次数：{{ item.standardTimes }}</p>
								<p>
									资质等相关信息
									<a v-if="item.companyFile" target="blank" download
										:href="FILE_BASE_URL + item.companyFile">{{ getFileName(item.companyFile) }}</a>
									<span v-else>无</span>
								</p>
							</div>
						</div>
					</el-tab-pane>
					<el-tab-pane v-if='infoData.publicationDetailSubItem.pfwzZ13.length>0'>
						<template #label>
							<span class="custom-tabs-label">
								<span>无组织排放</span>
							</span>
						</template>
						<div class="pub_detail_item_contents">
							<div class="pub_detail_item" v-for="(item, index) in infoData.publicationDetailSubItem.pfwzZ13"
								:key="item.id">
								<p>无组织排放监测点位名称：{{ item.name }}</p>
								<p>大气污染物实际排放总量：{{ item.gasAmount }}</p>
								<p>大气污染物实际排放浓度：{{ item.gasConcentrations }}</p>
								<p>监测点位主要水污染物实际排放总量：{{ item.waterAmount }}</p>
								<p>水污染物实际排放浓度：{{ item.waterConcentrations }}</p>

							</div>
						</div>
					</el-tab-pane>
					<el-tab-pane v-if='infoData.publicationDetailSubItem.pfzZ13.length>0'>
						<template #label>
							<span class="custom-tabs-label">
								<span>有组织排放</span>
							</span>
						</template>
						<div class="pub_detail_item_contents">
							<div class="pub_detail_item" v-for="(item, index) in infoData.publicationDetailSubItem.pfzZ13"
								:key="item.id">
								<p>主要排污口各项污染物的实际排放总量：{{ item.amountAll }}</p>
								<p>大气污染物小时浓度的年度平均值：{{ item.gasAmount }}</p>
								<p>水污染物和大气污染物排污口的数量：{{ item.portNumber }}</p>
								<p>水污染物日均浓度的年度平均值：{{ item.waterAmount }}</p>
								<p>各排污口安装污染源在线自动监测设备及与生态环境部门联网情况：{{ item.remark }}</p>
							</div>
						</div>
					</el-tab-pane>
					<el-tab-pane v-if='infoData.publicationDetailSubItem.gfwF14.length>0'>
						<template #label>
							<span class="custom-tabs-label">
								<span>危废处置</span>
							</span>
						</template>
						<el-alert title="若附件不能下载，请联系公开单位，依申请获取附件内容" type="warning" :closable="false">
						</el-alert>
						<div class="pub_detail_item_contents">
							<div class="pub_detail_item" v-for="(item, index) in infoData.publicationDetailSubItem.gfwF14"
								:key="item.id">
								<p>
									资质以及危险废物转移联单
									<a v-if="item.companyFile" target="blank" download
										:href="FILE_BASE_URL + item.companyFile">{{ getFileName(item.companyFile) }}</a>
									<span v-else>无</span>
								</p>
								<p>名称：{{ item.name }}</p>
								<p>贮存、处置场所：{{ item.adress }}</p>
								<p>产生量：{{ item.buildAmount }}</p>
								<p>废物代码：{{ item.code }}</p>
								<p>受托方名称：{{ item.companyName }}</p>
								<p>危险特性等情况：{{ item.dangerRemark }}</p>
								<p>贮存量：{{ item.saveAmount }}</p>
								<p>累计贮存量：{{ item.saveAmountAll }}</p>
								<p>设施的面积：{{ item.saveArea }}</p>
								<p>利用处置量：{{ item.usedAmount }}</p>
								<p>利用处置方式：{{ item.useType }}</p>
								<p>主要有害成分：{{ item.wFContent }}</p>
								<p>经纬度坐标：{{ item.xy }}</p>
							</div>
						</div>
					</el-tab-pane>
					<el-tab-pane v-if='infoData.publicationDetailSubItem.gfcZ14.length>0'>
						<template #label>
							<span class="custom-tabs-label">
								<span>固废处置</span>
							</span>
						</template>
						<el-alert title="若附件不能下载，请联系公开单位，依申请获取附件内容" type="warning" :closable="false">
						</el-alert>
						<div class="pub_detail_item_contents">
							<div class="pub_detail_item" v-for="(item, index) in infoData.publicationDetailSubItem.gfcZ14"
								:key="item.id">
								<p>
									资格和技术能力
									<a v-if="item.companyFile" target="blank" download
										:href="FILE_BASE_URL + item.companyFile">{{ getFileName(item.companyFile) }}</a>
									<span v-else>无</span>
								</p>
								<p>贮存、处置场所：{{ item.adress }}</p>
								<p>面积：{{ item.area }}</p>
								<p>受托方名称：{{ item.companyName }}</p>
								<p>一般工业固体废物运输、利用、处置情况：{{ item.ccompanyUse }}</p>
								<p>设施的类型：{{ item.machineType }}</p>
								<p>累计贮存量：{{ item.remark }}</p>
								<p>经纬度坐标：{{ item.xy }}</p>
							</div>
						</div>
					</el-tab-pane>
					<el-tab-pane v-if='infoData.publicationDetailSubItem.yhW15.length>0'>
						<template #label>
							<span class="custom-tabs-label">
								<span>有害物排放</span>
							</span>
						</template>
						<div class="pub_detail_item_contents">
							<div class="pub_detail_item" v-for="(item, index) in infoData.publicationDetailSubItem.yhW15"
								:key="item.id">
								<p>有毒有害物质的名称：{{ item.name }}</p>
								<p>排放浓度：{{ item.concentrations }}</p>
								<p>排放总量等情况：{{ item.outAmount }}</p>
								<p>形态：{{ item.shape }}</p>
								<p>毒性：{{ item.toxic }}</p>
							</div>
						</div>
					</el-tab-pane>
					<el-tab-pane v-if='infoData.publicationDetailSubItem.zY16.length>0'>
						<template #label>
							<span class="custom-tabs-label">
								<span>噪音污染</span>
							</span>
						</template>
						<div class="pub_detail_item_contents">
							<div class="pub_detail_item" v-for="(item, index) in infoData.publicationDetailSubItem.zY16"
								:key="item.id">
								<p>噪声排放监测点位名称：{{ item.name }}</p>
								<p>执行标准：{{ item.standard }}</p>
								<p>排放限值：{{ item.limitValue }}</p>
								<p>实际排放值等信息：{{ item.actualValue }}</p>
								<p>位置：{{ item.adress }}</p>
							</div>
						</div>
					</el-tab-pane>
					<el-tab-pane v-if='infoData.publicationDetailSubItem.yC17.length>0'>
						<template #label>
							<span class="custom-tabs-label">
								<span>扬尘防治</span>
							</span>
						</template>
						<div class="pub_detail_item_contents">
							<div class="pub_detail_item" v-for="(item, index) in infoData.publicationDetailSubItem.yC17"
								:key="item.id">
								<p>施工扬尘、装卸物料采取的防治扬尘污的主要措施：{{ item.usedMethod }}</p>
							</div>
						</div>
					</el-tab-pane>
					<el-tab-pane v-if='infoData.publicationDetailSubItem.bZ18.length>0'>
						<template #label>
							<span class="custom-tabs-label">
								<span>编制公开</span>
							</span>
						</template>
						<div class="pub_detail_item_contents">
							<div class="pub_detail_item" v-for="(item, index) in infoData.publicationDetailSubItem.bZ18"
								:key="item.id">
								<p>应公开次数：{{ item.needTimes }}</p>
								<p>实际公开次数：{{ item.actualTimes }}</p>
								<p>发布信息：{{ item.remark }}</p>
							</div>
						</div>
					</el-tab-pane>
					<el-tab-pane v-if='infoData.publicationDetailSubItem.tpF19.length>0'>
						<template #label>
							<span class="custom-tabs-label">
								<span>碳排放</span>
							</span>
						</template>
						<div class="pub_detail_item_contents">
							<div class="pub_detail_item" v-for="(item, index) in infoData.publicationDetailSubItem.tpF19"
								:key="item.id">
								<p>配额清缴情况：{{ item.cleanAmount }}</p>
								<p>年度碳实际排放量及上一年度实际排放量：{{ item.amount }}</p>
								<p>排放设施：{{ item.machine }}</p>
								<p>核算方法等信息：{{ item.method }}</p>
							</div>
						</div>
					</el-tab-pane>
					<el-tab-pane v-if='infoData.publicationDetailSubItem.scsH20.length>0'>
						<template #label>
							<span class="custom-tabs-label">
								<span>强制性清洁生产审核</span>
							</span>
						</template>
						<div class="pub_detail_item_contents">
							<div class="pub_detail_item" v-for="(item, index) in infoData.publicationDetailSubItem.scsH20"
								:key="item.id">
								<p>实施强制性清洁生产审核的原因：{{ item.reason }}</p>
								<p>评估与验收结果：{{ item.result }}</p>
								<p>强制性清洁生产审核的实施情况：{{ item.work }}</p>
							</div>
						</div>
					</el-tab-pane>
					<el-tab-pane v-if='infoData.publicationDetailSubItem.yjcL21.length>0'>
						<template #label>
							<span class="custom-tabs-label">
								<span>突发环境事件</span>
							</span>
						</template>
						<div class="pub_detail_item_contents">
							<div class="pub_detail_item" v-for="(item, index) in infoData.publicationDetailSubItem.yjcL21"
								:key="item.id">
								<p>突发环境事件：{{ item.emergencyEvent }}</p>
								<p>处置情况：{{ item.dealResult }}</p>
							</div>
						</div>
					</el-tab-pane>
					<el-tab-pane  v-if='infoData.publicationDetailSubItem.yJ21.length>0'>
						<template #label>
							<span class="custom-tabs-label">
								<span>突发环境事件应急预案</span>
							</span>
						</template>
						<el-alert title="若附件不能下载，请联系公开单位，依申请获取附件内容" type="warning" :closable="false">
						</el-alert>
						<div class="pub_detail_item_contents">
							<div class="pub_detail_item" v-for="(item, index) in infoData.publicationDetailSubItem.yJ21"
								:key="item.id">
								<p>
									突发环境事件应急预案
									<a v-if="item.emergencyFile" target="blank" download
										:href="FILE_BASE_URL + item.emergencyFile">{{ getFileName(item.emergencyFile) }}</a>
									<span v-else>无</span>
								</p>
								<p>备案编号：{{ item.code }}</p>
								<p>备案机关：{{ item.org }}</p>
							</div>
						</div>
					</el-tab-pane>
					<el-tab-pane v-if='infoData.publicationDetailSubItem.xzcF23.length>0'>
						<template #label>
							<span class="custom-tabs-label">
								<span>行政处罚</span>
							</span>
						</template>
						<el-alert title="若附件不能下载，请联系公开单位，依申请获取附件内容" type="warning" :closable="false">
						</el-alert>
						<div class="pub_detail_item_contents">
							<div class="pub_detail_item" v-for="(item, index) in infoData.publicationDetailSubItem.xzcF23"
								:key="item.id">
								<p>
									行政处罚决定书原文等信息
									<a v-if="item.punishmentFile" target="blank" download
										:href="FILE_BASE_URL + item.punishmentFile">{{ getFileName(item.punishmentFile) }}</a>
									<span v-else>无</span>
								</p>
								<p>行政处罚决定书文号：{{ item.punishmentCode }}</p>
								<p>行政处罚决定书下达时间：{{ item.punishmentDate }}</p>
								<p>处罚部门：{{ item.punishmentOrg }}</p>
							</div>
						</div>
					</el-tab-pane>
					<el-tab-pane v-if='infoData.publicationDetailSubItem.rZ25.length>0'>
						<template #label>
							<span class="custom-tabs-label">
								<span>相关投融资</span>
							</span>
						</template>
						<el-alert title="若附件不能下载，请联系公开单位，依申请获取附件内容" type="warning" :closable="false">
						</el-alert>
						<div class="pub_detail_item_contents">
							<div class="pub_detail_item" v-for="(item, index) in infoData.publicationDetailSubItem.rZ25"
								:key="item.id">

								<p>投向等信息：{{ item.direction }}</p>
								<p>金额：{{ item.money }}</p>
								<p>融资形式：{{ item.way }}</p>
								<p>融资所投项目的应对气候变化、生态环境保护等相关信息：{{ item.remark }}</p>
							</div>
						</div>
					</el-tab-pane>

				</el-tabs>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		onMounted,
		reactive,
		ref
	} from "vue-demi";
	import api from "../../http/apis";
	import {
		ElMessageBox,
		ElMessage
	} from "element-plus";
	import {
		useStore
	} from "vuex";
	export default {
		setup() {
			const store = useStore();
			const tableData = ref(null);
			const infoData = reactive({
				tableData: [],
				loading: false,
				pageInfo: {},
				seletectInfo: {},
				regionName: '',
				searchInput: '',
				regionDataList: [],
				yearNum: new Date(),
				publicationDetailVisible: false,
				publicationDetailItem:{},
				publicationDetailSubItem:{}
			});
			const PHOTO_BASE_URL = "http://221.10.90.153:8082";
			const FILE_BASE_URL = "http://221.10.90.153:8082";
			const getTableData = async () => {
				infoData.loading = true
				if(infoData.regionName){
					infoData.regionName.forEach((item)=>{
						infoData.regionName = item
					})
				}
				const {
					data
				} = await api.companyApi.queryForOpen({
					companyName: infoData.searchInput,
					value:"",
					regionName: infoData.regionName,
					yearNum: infoData.yearNum.getFullYear(),
					page: infoData.pageInfo.pageIndex || 1,
					rows: infoData.pageInfo.pageSize || 20,
					sort:"",
				});
				if (data.isSuccessful) {
					infoData.loading = false
					infoData.tableData = data.resultObj.data
					infoData.pageInfo = data.resultObj.pagerInfo
				} else if (data.resultMsg) {
					ElMessage({
						message: data.resultMsg,
						type: "error",
					});
				} else {
					ElMessage({});
				}
			};
			getTableData()
			const getRegionList = async () => {
				const {
					data
				} = await api.companyApi.getManageToolMenu();
				if (data.isSuccessful) {
					infoData.regionDataList = data.resultObj
				} else if (data.resultMsg) {
					ElMessage({
						message: data.resultMsg,
						type: "error",
					});
				} else {
					ElMessage({});
				}
			};
			getRegionList()
			
			const handleSelect = (selection, row) => {
				if (selection.length > 1) {
					tableData.value.toggleRowSelection(selection[0], false)
					tableData.value.setCurrentRow(row)
				} else if (selection.length == 1) {
					// console.log(selection.length)
					tableData.value.setCurrentRow(row)
				} else if (selection == '') {
					tableData.value.toggleRowSelection(row, true)
				} else {}
			};
			const handleTableChange = (currentRow, oldCurrentRow) => {
				if (oldCurrentRow) {
					tableData.value.toggleRowSelection(oldCurrentRow, false)
					handleSelect('', currentRow)
				} else {
					handleSelect('', currentRow)
				}
			};
			return {
				infoData,
				getTableData,
				getRegionList,
				PHOTO_BASE_URL,
				FILE_BASE_URL,
				handleSelect,
				handleTableChange,
				tableData
			};
		},
		methods: {
			checkComInfo() {
				if (this.infoData.seletectInfo.baseCompanyId) {
					this.$router.push({
						path: "/system/userTable/comInfo",
						query: {
							comId: this.infoData.seletectInfo.baseCompanyId,
						},
					});
				} else {
					ElMessage({
						message: '请先选中企业后再查看！',
						type: "error",
					});
				}
			},
			async checkOpenInfo(id) {
				const {
					data
				} = await api.companyApi.getEditById(id);
				if (data.isSuccessful) {
					this.infoData.publicationDetailSubItem = data.resultObj;
					this.infoData.publicationDetailItem = this.infoData.publicationDetailSubItem.yearsInfo
					this.infoData.publicationDetailVisible = true;
				} else if (data.resultMsg) {
					ElMessage({
						message: data.resultMsg,
						type: "error",
					});
				} else {
					ElMessage({});
				}
			},
			handleSizeChange(val) {
				this.infoData.pageInfo.pageSize = val;
				this.getTableData();
			},
			handleCurrentChange(val) {
				this.infoData.pageInfo.pageIndex = val;
				this.getTableData();
			},
			handleTableCurrentChange(val) {
				this.infoData.seletectInfo = val
			},
			dateTrimmer(str) {
				if (str) {
					return str.split("T")[0] + ' ' + str.slice(11, 19);
				} else {
					return "无";
				}
			},
			getFileName(str) {
				if (str) {
					return str.split("/").slice(-1)[0];
				} else {
					return "";
				}
			},
			handleClose() {
				this.infoData.publicationDetailVisible = false
			}
		},
	};
</script>

<style scoped lang='scss'>
	@use "../../assets/scss/table.scss"as *;

	.pub_detail_item {
		text-align: left
	}
</style>
